import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, query } from 'lit/decorators';
import { t } from '../../utils/locale';

@customElement('checkbox-input')
export class CheckBoxInput extends LitElement {
  static get styles() {
    return [
      css`
        *,
        *:before,
        *:after {
          box-sizing: border-box;
      }

      :host {
        --color: rgba(13, 45, 95, 0.85);
        --disabled: #c1c1c1;
      }

      .checkbox {
        display: grid;
        grid-template-columns: -webkit-min-content auto;
        grid-template-columns: min-content auto;
        gap: 2.2rem;
        font-size: 2.5rem;
            color: var(--color);
          }
          .checkbox-control {
            display: inline-grid;
            width: 3.375rem;
            height: 3.375rem;
            border: 2px solid currentColor;
            border-radius: 0.25rem;
          }
          svg path {
            stroke: var(--color);
          }
          .checkbox-control--disabled {
            color: var(--btn-disabled-color);
            border: 2px solid var(--btn-disabled-color);
            cursor: not-allowed;
          }
          .checkbox--disabled {
            color: var(--disabled);
          }
          input[type=checkbox]:disabled + .checkbox-control {
            --color: var(--btn-disabled-color);
            border: 2px solid var(--btn-disabled-color);
            cursor: not-allowed;
          }
          
          input[type=checkbox]:disabled + svg path {
            stroke: var(--btn-disabled-color);
          }
          
          .checkbox-control svg {
            width: 1.25rem;
            transform: scale(0);
            transform-origin: center center;
          }

          .checkbox-input {
            display: grid;
            grid-template-areas: "checkbox";
          }
          .checkbox-input > * {
            grid-area: checkbox;
          }
          .checkbox-input input {
            opacity: 0;
            width: 1em;
            height: 1em;
          }
          .checkbox-input input[checked] + .checkbox-control svg {
            transform: scale(1) translate3d(0.75rem, 0.45rem, 0px)
          }
          .radio-label {
            font-size: 2rem;
            color: var(--c-select);
            line-height: 3rem;
          }
        
        `,
    ];
  };

  @property({ type: Boolean })
    customizations = false;

  @property({ type: Boolean })
    checkedInput = false;

  @property({ type: Boolean, attribute: 'disabled', reflect: true })
    disabled: boolean = false;

  @property({ type: String })
    answer: string = '';

  @query('#checkbox')
    checkbox!: HTMLInputElement;

  private onChecked() {
    this.dispatchEvent(new CustomEvent('handle-accept', { detail: { value: this.checkbox.checked } }));
    this.dispatchEvent(new CustomEvent('change', { detail: this.checkbox.checked }));
    this.checkedInput = this.checkbox.checked;
  };

  render() {
    const label = this.answer ? html`<label for="checkbox">${t(this.answer)}</label>` : nothing;
    return html`
      <label class="checkbox">
              <span class="checkbox-input">
                <input id="checkbox" ?disabled=${this.disabled} type="checkbox" name="checkbox"
                       @click="${this.onChecked}" ?checked=${this.checkedInput}>
                <span class="checkbox-control">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M1 5.68975L3.83928 9L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                             stroke-linejoin="round"/>
                    </svg>
                </span>
              </span>
        ${label}
        ${this.customizations ? html`
          <slot></slot>` : html`<span class="radio-label">${t('T_Accept')}</span>`}
      </label>
    `;
  }
}